<template>
    <div class="content mt20">
       <div class="account-content bgfff">
           <taskOrdersMenu></taskOrdersMenu>
       </div>
       <div class="account-bd">&nbsp;</div>
       <div class="bgfff">
            <div class="bd clearfix">
                <span class="fl mt5">指令类型：</span>
                <div class="dropdown-toggle fl">
                    <div class="dropdown">
                        <span>{{typeWord}}</span>
                        <i class="icons icons-down fr"></i>
                    </div>
                    <div class="drop-down">
                        <ul class="dropdown-menu dropdown-menu1" role="menu">
                            <li @click="OrderType(0)">
                               <a :class="(typeCurrent==0)?'active':''" href="javascript:void(0);">全部</a>
                            </li>
                            <li @click="OrderType(1)">
                               <a :class="(typeCurrent==1)?'active':''" href="javascript:void(0);">转发</a>
                            </li>
                            <li @click="OrderType(2)">
                               <a :class="(typeCurrent==2)?'active':''" href="javascript:void(0);">评论</a>
                            </li>
                            <li @click="OrderType(3)">
                               <a :class="(typeCurrent==3)?'active':''" href="javascript:void(0);">点赞</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="search fr">
                    <div class="search fl">
                        <input type="text" v-model="Searchtitle" class="input-text" name="search" @keyup="searcBotton" placeholder="请输入文章标题">
                    </div>
                    <button class="btn btn-blue" @click="searcBotton"><i class="icons search-icon"></i></button>
                </div>

            </div>
            <div class="">
                <div class="no-data" v-if="nodata"><span class="text">没有数据哦...</span></div>
                <div class="clearfix listloop-wrap profile" v-for="(item,index) in mediaList" :key="index">
                    <div class="fl profile-img">
                        <img :src="item.newsImg" width="180" height="100" />
                    </div>
                    <div class="fr profile-btn mt40">
                        <router-link :to="{path:'/onlineEdit',query:{formType:1,id:item.mid}}" class="edit color-blue"><i class="icons icon-edit"></i>编辑</router-link>
                        <a href="javascript:void(0);" class="collec color-red ml10 active" @click="handleClick(item.status,item.id,item.type)"><i class="icons handle-icon"></i><span v-text="(item.status==0)?'处理':'已处理'"></span></a>
                    </div>
                    <div class="profile-info">
                        <h3 class="profile-tit"><a :href="item.newsUrl" target="_blank">{{item.newsTitle}}</a></h3>
                        <p class="profile-art color-gray fs12">
                            <span class="color_gray time"><i class="icons time-icon"></i>接收时间：{{item.addTime}}</span>
                            <span class="ml10 color_gray">Form：{{item.from}}</span>
                            <span class="ml10 color_gray" v-if="item.type=='转发'">To：{{item.to}}</span>
                            <span class="ml10 color_gray">指令类型：{{item.type}}</span>                            
                        </p>
                        <div class="profile-status mt30">
                            <span class="color_gray">指令要求：{{item.remark}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 分页 -->
            <page class="mt20" :currentPage.sync="currentPage" :limit.sync="limit" :totalCount="totalCount" @turn="getTableData"></page>
            
       </div>
        <!-- 提示弹框 -->
        <Dialog ref="handleDialog" type="normal" title="处理" width="422" :callback="handleModal">
            <div slot="mdBox">
                <div class="handle">
                    <div class="form-group clearfix" v-if="typeCurrent==1">
                        <label class="w mt5">已发布文章链接</label>
                        <div class="checkbox mt5">
                            <textarea rows="31" v-model="articleLink" placeholder="请输入已发布文章链接" class="input-text"></textarea>
                            <p v-html="tipsText" class="color-red fs12 mt5" ></p>
                        </div>
                    </div>
                    <div class="form-group clearfix" v-if="typeCurrent==2">
                        <label class="w mt5">已评论文章截图</label>
                        <div class="checkbox mt5">
                            <input type="text" class="input-text w298" v-model="imgUrl" placeholder="请上传评论截图" />
                            <div class="img-upload">
                                <img :src="imgUrl" style="display:none;"/>
								<input type="file" @change="addImg($event)" id="file_upload" name="file_upload" accept="image/*">
								<span>本地上传</span>
							</div>
                            <p v-html="tipsText" class="color-red fs12 mt5" ></p>
                        </div>
                    </div>
                    <div class="form-group clearfix" v-if="typeCurrent==3">
                        <label class="w mt5">已点赞文章截图</label>
                        <div class="checkbox mt5">
                            <input type="text" class="input-text w298" v-model="imgUrl" placeholder="请上传评论截图" />
                            <div class="img-upload">
								<input type="file" @change="addImg($event)" id="file_upload" name="file_upload" accept="image/*">
								<span>本地上传</span>
							</div>
                            <p v-html="tipsText" class="color-red fs12 mt5" ></p>
                        </div>
                    </div>
                </div>
            </div>
        </Dialog>
  	</div>
</template>
<script>
import Page from '@/components/page'
import Dialog from '@/components/dialog'
import taskOrdersMenu from './taskOrdersMenu.vue'
export default {
    components: {Page,Dialog,taskOrdersMenu},
    data() {
        return {
           mediaList:[],//微信列表
           currentPage:1,//当前条数
           limit:10,//每页显示条数
           totalCount:0,//总条数
           typeId:1,//id
           imgUrl:'',//图片url
           typeCurrent:0,//指令类型
           Searchtitle:'',//搜索
           typeWord:'全部',//指令类型文字
           articleLink:'',//文章链接
           tipsText:'',//处理弹框提示文字 
           formData:new FormData(),//图片流
           nodata:false,
           

        }
    },
    mounted() {
        let that = this;
        if(that.$route.query.type==undefined){
            that.typeWord = '全部'
            that.typeCurrent = 0;
        }else{
            that.typeWord = that.$route.query.type1;
            that.typeCurrent = that.$route.query.type;
            
        }
        that.dataAjax(0);
        
    },
    created() {
		
    },
    methods: {
        // editClick(id,type){
        //     let that =this;
        //     that.typeId = id;
        //     that.$api.post('/editor/editarticle',{type:type,sn:that.typeId,source:1},r=>{
        //         that.$parent.returnCode(r,function(){
        //             that.$router.push({
        //                 path: '/onlineEdit',
        //                 query: {
        //                     formType:type,
        //                     id:id,
        //                 }
        //             });
        //         })
        //     })
        // },
        addImg(e){
            let that = this;
            e.imgUrl =''
            let file =e.target.files;
            let files = file[0];
            let formData = new FormData();
            formData.append('file',files);
            that.$api.post('/mymaterial/upload',formData,r=>{
                that.$parent.returnCode(r,function(){
                    that.imgUrl = r.data;
                    //console.log(that.imgUrl);
                })
            })
        },
        handleModal(id,){//处理弹框确定
            let that = this;
            id = that.typeId;
            if(that.typeCurrent==1){
                that.imgUrl = that.articleLink;
            }
            if(that.imgUrl==''){
                if(that.typeCurrent==1){
                    that.tipsText ='请输入已发布文章链接！';
                }else if(that.typeCurrent==2){
                    that.tipsText ='请上传评论截图！';
                }else if(that.typeCurrent==3){
                    that.tipsText ='请上传评论截图！';
                }
                return;
            }
           
            that.$api.post('/order/handle',{id:that.typeId,url:that.imgUrl},r=>{
                that.$parent.returnCode(r,function(){
                   //that.status = 1;
                   let text= r.msg;
                   that.$utils.alertText(text,100,2000);
                   that.dataAjax();
                })
            })
            that.$refs.handleDialog.closeMask();
        },
        handleClick(status,id,type){//处理弹框显示
            let that =this;
            that.imgUrl = '';
            that.tipsText ='';
            if(status==1){
                return;
            }
            that.$refs.handleDialog.showMaskFun();
            if(type==='转发'){
                that.typeCurrent = 1
            }else if(type==='评论'){
                that.typeCurrent = 2
            }else if(type==='点赞'){
                that.typeCurrent = 3
            }
            that.typeId = id;

        },
        searcBotton(){//搜索
            let that = this;
            // if(that.Searchtitle==''){
            //     return;
            // }
            that.dataAjax(0);
        },
        OrderType(type){//指令类型选择
            let that = this;
            that.typeCurrent = type;
            if(type==0){
                that.typeWord = '全部'
            }else if(type==1){
                that.typeWord = '转发'
            }else if(type==2){
                that.typeWord = '评论'
            }else if(type==3){
                that.typeWord = '点赞'
            }
            that.$router.push({
                path: '/taskOrders',
                query: {
                    type: type,
                    type1:that.typeWord,
                }
            });
            that.typeCurrent = that.$route.query.type;
            that.typeWord = that.$route.query.type1;

            that.dataAjax(0);
        },
        getTableData(type){//分页
            let that = this;
            type = that.currentPage;

            that.dataAjax();
        },
        dataAjax(cPage){//指令列表
            let that = this;
            let url = '';
            cPage = 1;
            if(cPage==0){
                that.currentPage = 1;
            }
            that.$parent.loadModal(true,'正在加载...');
            //return;
            that.$api.post('/order/needlist',{page:that.currentPage,pagesize:that.limit,type:that.typeCurrent,title:that.Searchtitle},r=>{
                that.$parent.showLoad = false;
                that.$parent.returnCode(r,function(){
                   that.mediaList=r.data.list;
                   that.totalCount = Number(r.data.total);
                   if(that.mediaList.length<=0){
                       that.nodata = true;
                   }else{
                       that.nodata = false;
                       
                   }
              })
            })
       }
       
	}
}
</script>



// WEBPACK FOOTER //
// src/page/taskOrders/taskOrders.vue